import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from '@/utils/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for advanced caching and offline support
// Temporarily disabled to fix slow loading issues
// serviceWorkerRegistration.register();
serviceWorkerRegistration.unregister();
